/** Legacy baseline before per-minute spawn rate (≈ one spawn every 2.2s at multiplier 1). */
export const TOWER_LEGACY_SPAWN_INTERVAL_MS = 2200;

/** Default spawn rate for new GM rows (ตัว/นาที). */
export const TOWER_DEFAULT_SPAWN_PER_MINUTE = 30;

export function clampSpawnPerMinute(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return TOWER_DEFAULT_SPAWN_PER_MINUTE;
  }
  return Math.min(600, Math.max(0.5, Math.round(value * 10) / 10));
}

export function legacySpawnFrequencyToPerMinute(freq: number): number {
  const f = Math.min(100, Math.max(0.1, freq));
  return clampSpawnPerMinute((60_000 / TOWER_LEGACY_SPAWN_INTERVAL_MS) * f);
}

/** Delay before the next monster in the spawn queue (same row rate applies per instance). */
export function towerSpawnDelayMs(spawnPerMinute: number | undefined): number {
  const ppm = clampSpawnPerMinute(spawnPerMinute);
  return Math.max(250, Math.round(60_000 / ppm));
}
